import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Resource } from "../coreResource";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private resource: Resource,
  ) {}

  accessControlBody = this.resource.accessControlRequest;

  getAccessControl(entityType?: string, clientId?: string, reference?: string) {
    let url = `${environment.url}${this.resource.accessControl}`;

    if (entityType) {
      url += `/${entityType}`;
    }

    if (clientId) {
      url += `/${clientId}`;
    }

    if (reference) {
      url += `/${reference}`;
    }

    return this.http.get(url);
  }
}
